export function getTranslations(translations, locale) {
    if (locale === void 0) { locale = 'nl'; }
    var result = {};
    for (var id in translations[0]) {
        if (translations[0].hasOwnProperty(id)) {
            result[id] = translations[0][id][locale];
        }
    }
    return result;
}
